import { render } from "./AiInfoItem.vue?vue&type=template&id=6a9fd8f0"
import script from "./AiInfoItem.vue?vue&type=script&lang=js"
export * from "./AiInfoItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__